import axios from 'axios'

export default class Notificacoes {
  constructor(tokenBearer, url) {
    this.url = `${url}/api/notificacoes`
    this.tokenBearer = tokenBearer
  }
  async getNotificacoes(idUnimed, pagina = 1, tamanhoPagina = 10) {
    const urlApi = `${this.url}?idUnimed=${idUnimed}&tamanhoPagina=${tamanhoPagina}&pagina=${pagina}`;
    let notificacoes = {
      method: 'get',
      url: urlApi,
      headers: { Authorization: this.tokenBearer }
    }
    return await axios(notificacoes)
  }
  async gerarNotificacao(data){
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.url}`,
        headers: {
          Authorization: this.tokenBearer
        },
        data: {
          idAlerta: data
        }
      }
      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  } 

  async marcarNotificacaoComoResolvido(idUnimed, versaoUnimed, tipoAlerta){
    return await axios({
      method: 'delete',
      url: `${this.url}`,
      headers: { Authorization: this.tokenBearer },
      data: {
        tipoAlerta: tipoAlerta,
        idUnimed: idUnimed,
        versaoUnimed: versaoUnimed
      }
    })
  }
}


